import { useCallback } from "react";
import { recompileActiveSpace } from "../lib/recompileScene";

/** Recompile the active SpaceDescriptor into a SceneDescriptor for real-time preview */
export function useRecompileScene() {
  return useCallback(() => recompileActiveSpace(), []);
}
